/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Autodraft/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BankAccount from './BankAccount/index'
import CreditCard from './CreditCard/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Autodraft({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/TreatmentRequestOverride/Content/Autodraft"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Autodraft.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-ZJ9cmq': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-2-ZJ9cmq': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-ZJ9cmq': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-ZJ9cmq': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 text="Autodraft"
/>
<BankAccount
  viewPath={`${viewPath}/BankAccount`}
/>
<CreditCard
  viewPath={`${viewPath}/CreditCard`}
/>
</div>
{children}
</React.Fragment>)
}